import i18n from 'i18next';
import { Module } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enCommon from './locales/en/common.json';

const typedLanguageDetector: Module = LanguageDetector as unknown as Module;

// Configure i18next
i18n
  .use(typedLanguageDetector)
  .use(initReactI18next)

  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    load: 'languageOnly', // Only load the base language code (en) instead of full locale (en-GB)
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    defaultNS: 'common',
    resources: {
      en: {
        common: enCommon,
      },
      // Add more languages here as needed
    },
  });

export default i18n;
